import { makeStyles } from '@material-ui/styles';

const TABS_HEADER_HEIGHT = 80;

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
  },
  chatListContainer: {
    height: `calc(100% - ${TABS_HEADER_HEIGHT}px)`,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'auto',
  },
  tabs: {
    height: TABS_HEADER_HEIGHT,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    position: 'relative',
    zIndex: 100,
    root: {
      textTransform: 'none',
      fontSize: 16,
    },
  },
  tab: {
    width: '25%',
    minWidth: '25%',
    display: 'flex',
    justifyContent: 'center',
  },
  tabIcon: {
    fill: theme.palette.colors.monteCarlo,
  },
  chatsPlaceholder: {
    marginTop: 30,
    padding: 10,
    backgroundColor: theme.palette.colors.warning,
    borderRadius: 8,
  },
  badge: {
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    transform: 'scale(1) translate(80%, -40%)',
  },
  chatsEnd: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: 10,
    backgroundColor: theme.palette.colors.warning,
    borderRadius: 8,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyersChatList/useStyles.js